/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from "@azure/msal-browser";

 export const loginRequest = {
    scopes: [process.env.REACT_APP_LOGIN_REQUEST_SCOPE]
 };
 
export const msalConfig = {
    // dev
    
    auth: { 
        clientId:process.env.REACT_APP_MSAL_CONFIG_CLIENT_ID,
        authority: process.env.REACT_APP_MSAL_CONFIG_AUTHORITY,
        redirectUri: process.env.REACT_APP_MSAL_CONFIG_REDIRECT_URI
    }, 
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {	
        loggerOptions: {	
            loggerCallback: (level, message, containsPii) => {	
                if (containsPii) {		
                    return;		
                }		
                /*
                switch (level) {		
                    case LogLevel.Error:		
                        console.error(message);		
                        return;		
                    case LogLevel.Info:		
                        console.info(message);		
                        return;		
                    case LogLevel.Verbose:		
                        console.debug(message);		
                        return;		
                    case LogLevel.Warning:		
                        console.warn(message);		
                        return;		
                }
                 */	
            }	
        }	
    }
};
export const graphConfig = {
    graphMeEndpoint: "Enter_the_Graph_Endpoint_Herev1.0/me"
};